import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiCopy } = FiIcons;

function GeneratedCode({ code, mode, onModeChange }) {
  const [status, setStatus] = useState('idle');

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setStatus('copied');
    } catch {
      setStatus('failed');
    }
    window.setTimeout(() => setStatus('idle'), 2200);
  };

  return (
    <>
      <div className="code-options">
        <div className="mode-switch" role="group" aria-label="Generated code format">
          <button
            type="button"
            className={mode === 'inline' ? 'active' : ''}
            aria-pressed={mode === 'inline'}
            onClick={() => onModeChange('inline')}
          >
            Inline
          </button>
          <button
            type="button"
            className={mode === 'html-css' ? 'active' : ''}
            aria-pressed={mode === 'html-css'}
            onClick={() => onModeChange('html-css')}
          >
            HTML + CSS
          </button>
        </div>
      </div>

      <div className="code-wrap">
        <div className="code-toolbar">
          <span><i />button-snippet.html</span>
          <div className="copy-wrap">
            {status !== 'idle' && (
              <span className={`copy-tooltip ${status}`} role="status">
                {status === 'copied' ? 'Copied!' : 'Copy failed'}
              </span>
            )}
            <button
              className={`copy-button ${status === 'copied' ? 'copied' : ''}`}
              type="button"
              onClick={copyCode}
              aria-label="Copy button code"
              title="Copy code"
            >
              <SafeIcon icon={status === 'copied' ? FiCheck : FiCopy} />
            </button>
          </div>
        </div>
        <pre className="code-content"><code>{code}</code></pre>
      </div>
    </>
  );
}

export default GeneratedCode;